// extracted by mini-css-extract-plugin
export default {"content":"AJkDFD","summary":"SUHrxc","headerTitle":"Ajdzx6","statusTitle":"suHpYb"};